// extracted by mini-css-extract-plugin
export default {"container":"sBqPw","placeInfo":"L0FvZ","ticketInfo":"wt9qN","ticketPrice":"uUkbV"};